import apiClient from '@u/apiClient'

let base_errors = {}
export default {
  //region fetch
  async fetchAssetIndex({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get('api/asset')
      .then(async (response) => {
        await commit('setAssetList', response.data)
      })
      .catch((reason) => {
        console.error('storeNewImplantation', reason)
      })
  },
  async fetchAssetByID({ commit }, id) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get(`api/asset/${id}`)
      .then(async (response) => {
        await commit('setAsset', response.data.asset)
        await commit('setAssetMetadata', response.data.metadata)
      })
      .catch((reason) => {
        console.error('storeNewImplantation', reason)
      })
  },
  async fetchNewAsset({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get('api/model/new?model=asset')
      .then(async (response) => {
        await commit('setAsset', response.data.asset)
        await commit('setAssetMetadata', response.data.metadata)
      })
      .catch((reason) => {
        console.error('storeNewImplantation', reason)
      })
  },
  async fetchAssetActivitiesByAssetID({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get(`api/asset/fetch-activities/${payload.asset_id}`)
      .then(async (response) => {
        await commit('setAssetActivity', response.data.activities)
      })
      .catch(async (reason) => {
        await console.error(reason)
      })
  },
  //endregion

  //region store
  storeNewAsset({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return apiClient.post('api/asset', payload.asset).then(async (response) => {
      commit('setAsset', response.data.asset)
      return response.data
    })
  },
  storeTimeSlot({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return apiClient
      .put(`api/asset/add-timeslot/${payload.id}`, payload.timeSlot)
      .then(async (response) => {
        await commit('setAsset', response.data.data)
        return response.data
      })
  },

  //endregion

  //region update
  updateAsset({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return apiClient
      .put(`api/asset/${payload.id}`, payload.asset)
      .then(async (response) => {
        commit('setAsset', response.data.asset)
        return response.data
      })
  },
  //endregion

  //region delete
  deleteAssetById({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return apiClient
      .delete(`api/asset/${payload.id}`)
      .then(async (response) => {
        await commit('setAssetList', response.data)
        return response.data
      })
  },
  deleteTimeslotById({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return apiClient
      .delete(`api/timeslot/${payload.id}`)
      .then(async (response) => {
        await commit('setAsset', response.data.asset)
        await commit('setAssetMetadata', response.data.metadata)
        return response.data
      })
  },
  //endregion

  //region undoDelete
  undoDeleteAssetById({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return apiClient
      .get(`api/asset/undo-delete/${payload.id}`)
      .then(async (response) => {
        await commit('setAssetList', response.data)
        return response.data
      })
  },
  undoDeleteTimeslotById({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return apiClient
      .get(`api/timeslot/undo-delete/${payload.id}`)
      .then(async (response) => {
        await commit('setAsset', response.data.asset)
        await commit('setAssetMetadata', response.data.metadata)
        return response.data
      })
  }
  //endregion
}
